import { useEffect, useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { ResultListing } from "../../Result";
import { CognitiveResultListing } from "../CognitiveResults";
import { useParams } from "react-router-dom";
import { useTranslation } from "_metronic/i18n/language";
import { ResultQuizCognitiveType } from "../CognitiveResults/cognitive-result-view";
import { AudiometryResultPage } from "../AudiometryResults";
import { useResultsModel } from "./useResultsModel";
import { QuizApiServiceImpl } from "app/services";

type RouteParams = {
  id?: string;
};

let firstInterection = true;
const quizService = new QuizApiServiceImpl();

export default function NavTabs() {
  const { id } = useParams<RouteParams>();
  const translate = useTranslation();
  const {getQuizNameById} =  useResultsModel(quizService);
  const [value, setValue] = useState<number>(1);
  const accountId = Number(id) || 0;

  useEffect(() => {
    firstInterection = true;
  }, []);

  const processResultCognitive = (result: ResultQuizCognitiveType[]): void => {
    if (firstInterection && result.length === 0) {
      setValue(0);
    }
    firstInterection = false;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={(_, newValue) => setValue(newValue)}
        textColor="secondary"
        indicatorColor="secondary"
        variant="fullWidth"
        centered
      >
        <Tab label={translate("screens_testResults_olfactory")} />
        <Tab label={translate("screens_testResults_cognitive")} />
        <Tab label={translate("screens_testResults_audiometry")} />
      </Tabs>
      {value === 0 && <ResultListing account={accountId} />}
      {value === 1 && (
        <CognitiveResultListing
          processResultCognitive={processResultCognitive}
        />
      )}
      {value === 2 && <AudiometryResultPage getQuizNameById={getQuizNameById} />}
    </Box>
  );
}
